import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { PreloadScene } from './scenes/PreloadScene';
import { RouletteScene } from './scenes/RouletteScene';

import './assets/styles/style.scss';

const config: Phaser.Types.Core.GameConfig = {
	type: Phaser.AUTO,
	parent: 'container',
	transparent: true,
	scene: [BootScene, PreloadScene, RouletteScene],
	scale: {
		width: 1280, // game width, in pixels 1850
		height: 720, // game height, in pixels 1077
		mode: Phaser.Scale.ScaleModes.FIT
	},
	render: {
		powerPreference: 'high-performance',
		mipmapFilter: 'LINEAR'
	}
};

const game = new Phaser.Game(config);
